import React, {useEffect, useState} from 'react';
import styles from '../styles/components/EditUserForm.module.css';
import { load_fetch } from "../pr_utils";

const EditUserForm = ({ person, availableRoles, closeForm, onPasswordReset, onUsernameChange, onRoleChange, errorMessage }) => {
    const [username, setUsername] = useState(person.username || '');
    const [editingUsername, setEditingUsername] = useState(false);

    const [selectedRoles, setSelectedRoles] = useState(person.roles || []);
    const [editingPassword, setEditingPassword] = useState(false);
    const [password, setPassword] = useState('');

    useEffect(() => {
        setUsername(person.username || '');
        setSelectedRoles(person.roles || []);
        setPassword('');
        setEditingUsername(false);
        setEditingPassword(false);
    }, [person]);


    const passwordChecks = {
        length: password.length >= 8,
        number: /\d/.test(password),
        special: /[!@#$%^&*-]/.test(password),
    };

    const handleRoleToggle = (role) => {
        setSelectedRoles((prev) =>
            prev.includes(role)
                ? prev.filter((r) => r !== role)
                : [...prev, role]
        );
    };

    const generatePassword = () => {
        load_fetch("Security_Handler.php", { operation: 'GENERATE_PASSPHRASE' }, (data) => {
            if (!data.ERROR && data.DATA) {
                setPassword(data.DATA);
            } else {
                console.log("Failed to generate passphrase.", data);
            }
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            operation: 'EDIT_USER_DETAILS',
            person_id: person.person_id,
            roles: selectedRoles,
        };

        if (editingUsername) payload.username = username;
        if (editingPassword) payload.password = password;

        load_fetch("Security_Handler.php", payload, (data) => {
            if (!data.SUCCESS) {
                console.log(data);
            } else {
                closeForm();
            }
        });
    };

    // Ajax Functions
    const submitChangeUsername = (e) => {
        e.preventDefault();
        onUsernameChange(username);
        setEditingUsername(false);
    }
    const submitChangePassword = (e) => {
        e.preventDefault();
        onPasswordReset(password);
        setEditingPassword(false);
    }
    const submitChangeRoles = (e) => {
        e.preventDefault();
        console.log("OLD ROLES: ");
        console.log(person.roles);
        console.log("NEW ROLES: ");
        console.log(selectedRoles);
        onRoleChange(selectedRoles);
    }


    return (
        <form className={styles.edit_user_form} onSubmit={handleSubmit}>
            <div className={errorMessage ? styles.errorMessageDiv : styles.hidden}>
                {errorMessage}
            </div>
            <div>
                <label>Username:</label> {!editingUsername ? username : ''}
                {editingUsername ? (
                    <div>
                        <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
                        <button type="button" onClick={() => { setEditingUsername(false); setUsername(person.username); }}>Cancel</button>
                        <button type="button" onClick={submitChangeUsername}>Submit</button>
                    </div>
                ) : (
                    <div>
                        <button type="button" onClick={() => setEditingUsername(true)}>Change Username</button>
                    </div>
                )}
            </div>

            <div>
                <label>Password {person.has_password_hash ? '' : '[NO PASSWORD SET]'}:</label>
                {editingPassword ? (
                    <div>
                        <input
                            type="text"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <button type="button" onClick={generatePassword}>Generate</button>
                        <button type="button" onClick={submitChangePassword}>Submit</button>
                        <button type="button" onClick={() => { setEditingPassword(false); setPassword(''); }}>Cancel</button>

                        <div className={styles.password_requirements}>
                            <div className={passwordChecks.length ? styles.valid : styles.invalid}>
                                Minimum 8 characters
                            </div>
                            <div className={passwordChecks.number ? styles.valid : styles.invalid}>
                                At least one number
                            </div>
                            <div className={passwordChecks.special ? styles.valid : styles.invalid}>
                                At least one special character (!@#$%^&*)
                            </div>
                        </div>
                    </div>
                ) : (
                    <button type="button" onClick={() => setEditingPassword(true)}>Reset Password</button>
                )}
            </div>

            <div className={styles.roles_container}>
                <div>
                    <label><input type="checkbox" checked={selectedRoles.includes('ADMIN')} onChange={() => handleRoleToggle('ADMIN')} /> ADMIN</label>
                </div>
                <div>
                    <label><input type="checkbox" checked={selectedRoles.includes('DIRECTORY_EDITOR')} onChange={() => handleRoleToggle('DIRECTORY_EDITOR')} /> DIRECTORY_EDITOR</label><br />
                    <label><input type="checkbox" checked={selectedRoles.includes('DIRECTORY_VIEWER')} onChange={() => handleRoleToggle('DIRECTORY_VIEWER')} /> DIRECTORY_VIEWER</label>
                </div>
                <div>
                    <label><input type="checkbox" checked={selectedRoles.includes('SERVICE_EDITOR')} onChange={() => handleRoleToggle('SERVICE_EDITOR')} /> SERVICE_EDITOR</label><br />
                    <label><input type="checkbox" checked={selectedRoles.includes('SERVICE_VIEWER')} onChange={() => handleRoleToggle('SERVICE_VIEWER')} /> SERVICE_VIEWER</label>
                </div>
            </div>
            <button type="button" onClick={() => setSelectedRoles([])}>Remove All Roles</button>
            <button type="button" onClick={submitChangeRoles}>Save Role Changes</button>
        </form>
    );
};

export default EditUserForm;
